import { supabase } from "@/integrations/supabase/client";

/**
 * Busca uma tabela inteira, sem o teto silencioso do servidor.
 *
 * O PostgREST corta toda resposta no limite de linhas configurado no projeto
 * — aqui, 1.500. Uma consulta sem `.range()` não dá erro nenhum: devolve as
 * primeiras 1.500 linhas e fica quieta. Era por isso que a tela de Recetas
 * dizia "1500 recetas" tendo 2.509 no banco: mil delas não existiam para o
 * usuário, e nada no app indicava que faltava algo.
 *
 * `buscarTodas` pede a primeira página com `count: "exact"`, descobre o total
 * e busca o resto em paralelo. Se a tabela crescer, continua funcionando.
 */
export async function buscarTodas<T = any>(
  tabela: string,
  colunas: string,
  aplicarFiltros?: (q: any) => any,
  tamanhoPagina = 1000,
): Promise<T[]> {
  const montar = () => {
    const base = (supabase.from(tabela as any) as any).select(colunas, { count: "exact" });
    return aplicarFiltros ? aplicarFiltros(base) : base;
  };

  const { data: primeira, error, count } = await montar().range(0, tamanhoPagina - 1);
  if (error) throw error;

  let linhas: any[] = primeira || [];
  if (count && count > tamanhoPagina) {
    const paginas = Math.ceil((count - tamanhoPagina) / tamanhoPagina);
    const pedidos = Array.from({ length: paginas }, (_, i) => {
      const de = (i + 1) * tamanhoPagina;
      const base = aplicarFiltros
        ? aplicarFiltros((supabase.from(tabela as any) as any).select(colunas))
        : (supabase.from(tabela as any) as any).select(colunas);
      return base.range(de, de + tamanhoPagina - 1);
    });
    const extras = await Promise.all(pedidos);
    for (const { data } of extras) if (data) linhas = linhas.concat(data);
  }

  return linhas as T[];
}
